import { useState, useEffect } from 'react'
import './App.css'
import IMacHealth from './IMacHealth'

// Define the redirect sites
const redirectSites = [
  { name: 'Google', url: 'https://www.google.com', description: 'Motor de Busca', icon: '🔍', category: 'featured' },
  { name: 'GitHub', url: 'https://github.com', description: 'Repositório de Código', icon: '💻', category: 'featured' },
  { name: 'YouTube', url: 'https://www.youtube.com', description: 'Plataforma de Vídeos', icon: '🎬', category: 'featured' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com', description: 'Rede Profissional', icon: '👔', category: 'featured' },
  { name: 'Twitter', url: 'https://twitter.com', description: 'Rede Social', icon: '🐦', category: 'social' },
  { name: 'Instagram', url: 'https://www.instagram.com', description: 'Partilha de Fotos', icon: '📸', category: 'social' },
  { name: 'Facebook', url: 'https://www.facebook.com', description: 'Rede Social', icon: '👥', category: 'social' },
  { name: 'WhatsApp Web', url: 'https://web.whatsapp.com/', description: 'Mensagens Online', icon: '💬', category: 'social' },
  { name: 'Netflix', url: 'https://www.netflix.com', description: 'Serviço de Streaming', icon: '🎬', category: 'entertainment' },
  { name: 'Disney+', url: 'https://www.disneyplus.com/', description: 'Serviço de Streaming', icon: '🎭', category: 'entertainment' },
  { name: 'Max', url: 'https://www.max.com/', description: 'Serviço de Streaming HBO', icon: '📽️', category: 'entertainment' },
  { name: 'Prime Video', url: 'https://www.primevideo.com/', description: 'Serviço de Streaming Amazon', icon: '🎞️', category: 'entertainment' },
  { name: 'Netlify', url: 'https://www.netlify.com', description: 'Plataforma de Alojamento Web', icon: '🌐', category: 'featured' },
 
  // AI section
  { name: 'ChatGPT', url: 'https://chat.openai.com', description: 'Chatbot OpenAI', icon: '🤖', category: 'ai' },
  { name: 'Bard', url: 'https://bard.google.com', description: 'Assistente AI da Google', icon: '🧠', category: 'ai' },
  { name: 'Bing AI', url: 'https://www.bing.com/new', description: 'Pesquisa AI da Microsoft', icon: '🔎', category: 'ai' },
  { name: 'Midjourney', url: 'https://www.midjourney.com', description: 'Gerador de Imagens AI', icon: '🎨', category: 'ai' },
  { name: 'Hugging Face', url: 'https://huggingface.co', description: 'Plataforma de Modelos AI', icon: '🤗', category: 'ai' },
  // Personal sites section
  { name: 'ElevaChecks', url: 'https://elevachecks.com', description: 'Serviço de Verificação', icon: '✅', category: 'personal' },
  { name: 'Padel Master', url: 'https://padelmaster.club/', description: 'Clube & Comunidade de Padel', icon: '🎾', category: 'personal' },
  { name: 'Tabela Horas', url: 'https://tabelahoras.netlify.app/', description: 'Registo e Gestão de Horas', icon: '⏱️', category: 'personal' },
  // News section - Portuguese
  { name: 'Público', url: 'https://www.publico.pt', description: 'Jornal Diário Português', icon: '📰', category: 'news', subcategory: 'national' },
  { name: 'Jornal de Notícias', url: 'https://www.jn.pt', description: 'Jornal Diário do Porto', icon: '📰', category: 'news', subcategory: 'national' },
  { name: 'Diário de Notícias', url: 'https://www.dn.pt', description: 'Jornal Diário Nacional', icon: '📰', category: 'news', subcategory: 'national' },
  { name: 'Expresso', url: 'https://expresso.pt', description: 'Semanário Português', icon: '📰', category: 'news', subcategory: 'national' },
  { name: 'RTP Notícias', url: 'https://www.rtp.pt/noticias', description: 'Portal de Notícias da RTP', icon: '📺', category: 'news', subcategory: 'national' },
  
  // News section - International
  { name: 'BBC News', url: 'https://www.bbc.com/news', description: 'Notícias Britânicas', icon: '🌍', category: 'news', subcategory: 'international' },
  { name: 'CNN', url: 'https://edition.cnn.com', description: 'Notícias Americanas', icon: '🌍', category: 'news', subcategory: 'international' },
  { name: 'The Guardian', url: 'https://www.theguardian.com', description: 'Jornal Britânico', icon: '🌍', category: 'news', subcategory: 'international' },
  { name: 'Al Jazeera', url: 'https://www.aljazeera.com', description: 'Notícias do Médio Oriente', icon: '🌍', category: 'news', subcategory: 'international' },
  { name: 'Reuters', url: 'https://www.reuters.com', description: 'Agência de Notícias Internacional', icon: '🌍', category: 'news', subcategory: 'international' },
  // Services section
  { name: 'Iberdrola', url: 'https://www.iberdrola.pt/wclifreu/login/#/login', description: 'Serviço de Eletricidade', icon: '⚡', category: 'services' },
  { name: 'SMAS Sintra', url: 'https://www.smas-sintra.pt', description: 'Serviços Municipalizados de Água', icon: '💧', category: 'services' },
  { name: 'Vodafone', url: 'https://www.vodafone.pt/', description: 'Serviços de Telecomunicações', icon: '📱', category: 'services' },
  // Music section
  { name: 'Yousician', url: 'https://yousician.com/', description: 'Plataforma de Aprendizagem Musical', icon: '🎵', category: 'music' },
  { name: 'Spotify', url: 'https://open.spotify.com/', description: 'Streaming de Música', icon: '🎧', category: 'music' },
  // 3D section
  { name: 'Thingiverse', url: 'https://www.thingiverse.com/', description: 'Comunidade de Design 3D', icon: '🖨️', category: '3d' },
  { name: 'STLFlix', url: 'https://platform.stlflix.com', description: 'Plataforma de Streaming', icon: '📺', category: 'entertainment' },
  // Home servers section
  { name: 'iMac Status', url: 'https://status.myhubmain.com/health', description: 'Saúde do iMac (JSON)', icon: '🖥️', category: 'homeservers' },
  { name: 'Immich', url: 'https://fotos.myhubmain.com', description: 'Gestor de Fotos Pessoal', icon: '📷', category: 'homeservers' },
  { name: 'Jellyfin', url: 'https://jellyfin.myhubmain.com', description: 'Servidor de Média', icon: '🎬', category: 'homeservers' },
  { name: 'Paperless', url: 'https://paperless.elevachecks.com', description: 'Gestor de Documentos', icon: '📄', category: 'homeservers' },
  { name: 'Jellyseerr', url: 'https://pedidos.myhubmain.com', description: 'Pedidos de Filmes e Séries', icon: '🎥', category: 'homeservers' },
  { name: 'Radarr', url: 'https://radarr.myhubmain.com', description: 'Gestor de Filmes', icon: '🎞️', category: 'homeservers' },
  { name: 'Sonarr', url: 'https://sonarr.myhubmain.com', description: 'Gestor de Séries', icon: '📺', category: 'homeservers' },
  { name: 'Prowlarr', url: 'https://prowlarr.myhubmain.com', description: 'Gestor de Indexers', icon: '🔍', category: 'homeservers' },
  { name: 'qBittorrent', url: 'https://qbit.myhubmain.com', description: 'Cliente de Downloads', icon: '⬇️', category: 'homeservers' },
  { name: 'Bazarr', url: 'https://bazarr.myhubmain.com', description: 'Gestor de Legendas', icon: '💬', category: 'homeservers' },
  { name: 'Navidrome', url: 'https://musica.myhubmain.com', description: 'Servidor de Música', icon: '🎵', category: 'homeservers' },
  { name: 'Ombi', url: 'https://pedidosmusicas.myhubmain.com', description: 'Pedidos de Música', icon: '🎶', category: 'homeservers' },
  { name: 'Lidarr', url: 'https://lidarr.myhubmain.com', description: 'Gestor de Música', icon: '🎤', category: 'homeservers' },
]

function App() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  
  // Check screen size on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (menuOpen && !target.closest('.nav-menu') && !target.closest('.hamburger')) {
        setMenuOpen(false)
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuOpen])

  return (
    <div className={`app-container ${isMobile ? 'mobile' : 'desktop'}`}>
      <header className="header">
        <div className="logo">
          <span className="logo-text">RedirectHub</span>
        </div>
        
        {isMobile ? (
          <button 
            className={`hamburger ${menuOpen ? 'active' : ''}`} 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </button>
        ) : null}
        
        <nav className={`nav-menu ${menuOpen ? 'open' : ''} ${isMobile ? 'mobile' : 'desktop'}`}>
          <ul>
            <li><a href="#featured">Ligações em Destaque</a></li>
            <li><a href="#news">Notícias</a></li>
            <li><a href="#services">Serviços</a></li>
            <li><a href="#homeservers">Servidores Caseiros</a></li>
            <li><a href="#ai">Ferramentas IA</a></li>
            <li><a href="#social">Redes Sociais</a></li>
            <li><a href="#entertainment">Entretenimento</a></li>
            <li><a href="#music">Música</a></li>
            <li><a href="#3d">3D</a></li>
            <li><a href="#personal">Sites Pessoais</a></li>
            <li><a href="#about">Sobre</a></li>
          </ul>
        </nav>
      </header>
      
      <main>
        <section className="hero">
          <h1>{isMobile ? 'RedirectHub' : 'Bem-vindo ao RedirectHub'}</h1>
          <p>O seu portal para os destinos mais populares da web</p>
        </section>
        
        <section id="featured" className="redirect-section">
          <h2>Destinos em Destaque</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'featured')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="news" className="redirect-section">
          <h2>Notícias</h2>
          
          <h3>Jornais Nacionais</h3>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'news' && site.subcategory === 'national')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
          
          <h3>Jornais Internacionais</h3>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'news' && site.subcategory === 'international')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="ai" className="redirect-section">
          <h2>Inteligências Artificiais</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'ai')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="social" className="redirect-section">
          <h2>Redes Sociais</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'social')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="entertainment" className="redirect-section">
          <h2>Entretenimento</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'entertainment')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="music" className="redirect-section">
          <h2>Música</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'music')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="3d" className="redirect-section">
          <h2>3D</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === '3d')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
        
        <section id="personal" className="redirect-section">
          <h2>Sites Pessoais</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'personal')
              .map((site) => (
                <a 
                  key={site.name} 
                  href={site.url} 
                  className="redirect-card"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>

        <section id="homeservers" className="redirect-section">
          <h2>Servidores Caseiros</h2>
          <IMacHealth />
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'homeservers')
              .map((site) => (
                <a
                  key={site.name}
                  href={site.url}
                  className="redirect-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>

        <section id="services" className="redirect-section">
          <h2>Serviços Essenciais</h2>
          <div className={`redirect-grid ${isMobile ? 'mobile-grid' : ''}`}>
            {redirectSites
              .filter(site => site.category === 'services')
              .map((site) => (
                <a
                  key={site.name}
                  href={site.url}
                  className="redirect-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="card-icon">{site.icon}</div>
                  <h3>{site.name}</h3>
                  {!isMobile && <p>{site.description}</p>}
                </a>
              ))}
          </div>
        </section>
      </main>
      
      <footer>
        <p>&copy; {new Date().getFullYear()} RedirectHub. Todos os direitos reservados.</p>
      </footer>
    </div>
  )
}

export default App
